import React, { useEffect, useState } from 'react';

import { Progress } from '@mantine/core';
import { MAX_CRAWLING_TIME_MS } from 'shared/constants/progress-bar';

interface TimedProgressProps {
  isLoading?: boolean;
  duration?: number;
}
// Add 10 seconds to the duration to ensure the progress bar reaches 100%
const PROGRESS_BAR_DURATION_BUFFER = 10 * 1000;

export const TimedProgress = ({
  isLoading = true,
  duration = MAX_CRAWLING_TIME_MS + PROGRESS_BAR_DURATION_BUFFER
}: TimedProgressProps) => {
  const [progress, setProgress] = useState(0);
  const UPDATE_INTERVAL_MS = 100; // Frequency of progress updates
  const MAX_PROGRESS_CAP = 99; // Maximum progress cap before completion

  useEffect(() => {
    if (isLoading) {
      const startTime = Date.now();
      const intervalId = window.setInterval(() => {
        const elapsedTime = Date.now() - startTime;
        const progressRate = (elapsedTime / duration) * MAX_PROGRESS_CAP;
        setProgress(progressRate);

        if (progressRate >= MAX_PROGRESS_CAP) {
          window.clearInterval(intervalId);
        }
      }, UPDATE_INTERVAL_MS);

      return () => window.clearInterval(intervalId);
    } else {
      // Directly set to 100% once loading is complete
      setProgress(100);
    }
  }, [isLoading, duration]);

  return (
    <Progress
      value={Math.min(progress, 100)}
      label={progress > 5 ? `${Math.round(progress)}%` : ''}
      size="md"
      radius="xl"
      w="50%"
    />
  );
};
